import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger, Popover} from "react-bootstrap";
import Files from 'react-files';
import {withRouter} from "react-router-dom";

import Loading from "../../components/Loading/index";

class NewsfeedForm extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            file: [],
            inProcess: false,
            loading: this.props.match.params.id ? true : false,
            values: {
                name: '',
                text: '',
                link: '',
                enabled: false,
            },
            validation: {
                states: {
                    name: null,
                    text: null,
                    link: null,
                    file: null
                },
                messages: {
                    name: '',
                    text: '',
                    link: '',
                    file: ''
                }
            }
        };

        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeText = this.handleChangeText.bind(this);
        this.handleChangeLink = this.handleChangeLink.bind(this);
        this.handleChangeImage = this.handleChangeImage.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getNewsfeed();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getNewsfeed();
        }
    }

    getNewsfeed() {
        if (this.props.match.params.id) {
            axios.get(this.props.api.newsfeeds + "/" + this.props.match.params.id)
            .then((response) => {
                if (!this._componentWillUnmount) {
                    this.setState({
                        values: {
                            ...response.data
                        },
                        loading: false
                    });
                }
            }).catch((error) => {
                this.props.notoficationHandlers.addNotification('error', error.response.status, 'Nepodařilo se načíst novinku!');
                console.log('Axios error: ', error);
            });
        }
    }

    /* Handles */
    handleChangeName(event) {
        let value =  event ? event.target.value : this.state.values.name;

        let values = this.state.values;
        values.name = value;

        let validation = this.state.validation;
        validation.states.name = value === '' ? 'error' : 'success';
        validation.messages.name = value === '' ? 'Název novinky nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeText(event) {
        let value =  event ? event.target.value : this.state.values.text;

        let values = this.state.values;
        values.text = value;

        let validation = this.state.validation;
        validation.states.text = value === '' ? 'error' : 'success';
        validation.messages.text = value === '' ? 'Obsah novinky nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeLink(event) {
        let value =  event ? event.target.value : this.state.values.link;

        let values = this.state.values;
        values.link = value;

        let validation = this.state.validation;
        validation.states.link = value === '' ? 'error' : 'success';
        validation.messages.link = value === '' ? 'Odkaz na novinku nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeImage(image) {
        let {file, values, validation} = this.state;

        if (image && image.length !== 0) {
            let file = image[0];
            let img = new Image();
            // let sizeLimit = this.props.size;
            let component = this;
            img.onload = function() {
                // let height = img.height;
                // let width = img.width;

                // // dimension check
                // if (width !== sizeLimit.width || height !== sizeLimit.height) {
                //     file = [];
                //     values.pictureBase64 = undefined;
                //     validation.states.file = 'error';
                //     validation.messages.file = 'Rozměry fotky neodpovídají daným omezením!';
                //     component.setState({
                //         file,
                //         values,
                //         validation
                //     });
                // } else {
                //     file = image;
                //     let reader = new FileReader();
                //     reader.onload = function () {
                //         values.pictureBase64 = reader.result;
                //     };
                //     reader.readAsDataURL(file[0]);
                //     validation.states.file = 'success';
                //     validation.messages.file = '';
                //     component.setState({
                //         file,
                //         values,
                //         validation
                //     });
                // }

                file = image;
                let reader = new FileReader();
                reader.onload = function () {
                    values.pictureBase64 = reader.result;
                };
                reader.readAsDataURL(file[0]);
                validation.states.file = 'success';
                validation.messages.file = '';
                component.setState({
                    file,
                    values,
                    validation
                });
            };
            let _URL = window.URL || window.webkitURL;
            img.src = _URL.createObjectURL(file);
        } else {
            if ((file && file.length !== 0) || (this.props.match.params.id && this.state.values.picturePath)) {
                validation.messages.file = '';
                validation.states.file = 'success';
            }
            else {
                validation.messages.file = 'Musíte vložit obrázek!';
                validation.states.file = 'error';
            }
        }

        this.setState({
            values,
            validation
        })
    }

    handleClearImage() {
        let {values, file} = this.state;
        file = [];
        values.pictureBase64 = undefined;
        this.setState({
            file,
            values
        });
        this.refs.file.removeFiles()
    }

    isValid () {
        this.handleChangeName();
        this.handleChangeText();
        this.handleChangeLink();
        this.handleChangeImage();

        return (Object.values(this.state.validation.states).indexOf('error') < 0);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()){
            this.setState({inProcess: true});
            this.props.action(this.state.values);
        }
    }

    handleClose() {
        this.props.history.push('/newsfeeds');
    }

    render() {
        let {messages, states} = this.state.validation;
        let {file,values} = this.state;
        let title = this.props.match.params.id ? this.props.title + ' ' + this.state.values.name : this.props.title;

        const popoverInfo = (
            <Popover id="popover-info" title="Omezení nahráveného obrázku">
                <p>Obrázek musí splňovat tyto omezení:</p>
                <ul>
                    {/*<li><strong>Velikost</strong> musí být {this.props.size.width}x{this.props.size.height}</li>*/}
                    <li><strong>Formát obrázku</strong> musí být PNG.</li>
                </ul>
            </Popover>
        );

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <FormGroup controlId="name" validationState={states.name}>
                                        <ControlLabel>Název novinky <span className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={values.name} onChange={this.handleChangeName}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.name}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="link" validationState={states.link}>
                                        <ControlLabel>Odkaz na novinku <span
                                            className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={values.link} onChange={this.handleChangeLink}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.link}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="text" validationState={states.text}>
                                        <ControlLabel>Obsah novinky <span className="required">*</span></ControlLabel>
                                        <FormControl componentClass="textarea" value={values.text}
                                                     onChange={this.handleChangeText}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.text}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div
                                    className="col-lg-5 col-md-5 col-sm-5 col-xs-12 col-lg-offset-1 col-md-offset-1 col-sm-offset-1">
                                    <FormGroup controlId="file" validationState={states.file}>
                                        <ControlLabel>Obrázek <span className="required">*</span></ControlLabel>
                                        <Files
                                            ref='file'
                                            className='files-dropzone-gallery-single'
                                            onChange={this.handleChangeImage}
                                            accepts={['image/png']}
                                            multiple={false}
                                            clickable
                                        >
                                            <FormControl.Feedback/>
                                            {
                                                file.length > 0
                                                    ? <div className='files-gallery-single'>
                                                        {file.map((file, index) =>
                                                            <img className='files-gallery-single-item'
                                                                 src={file.preview.url} alt='' key={file.id}/>
                                                        )}
                                                    </div>
                                                    : this.state.values.picturePath ?
                                                    <img className='files-gallery-single-item'
                                                         src={`${__APIURL__}/${this.state.values.picturePath}`} alt=''/>
                                                    : <div>Zde vložte obrázek</div>
                                            }
                                        </Files>
                                        <Button type='button' className="btn btn-danger"
                                                onClick={this.handleClearImage}>Smazat</Button>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="right"
                                                        overlay={popoverInfo}>
                                            <FontAwesome name="info-circle" tag="i" size="2x"/>
                                        </OverlayTrigger>
                                        <HelpBlock>{messages.file}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div className="clearfix"/>
                                <div className="ln-solid"/>
                                <FormGroup>
                                    <div className="col-md-4 col-sm-4 col-xs-12 col-md-offset-4">
                                        <Button className="btn-primary" type="button"
                                                onClick={this.handleClose}>Zpět</Button>
                                        <Button type="submit" disabled={this.state.inProcess}
                                                className="btn btn-success">{this.props.button}</Button>
                                        {this.state.inProcess && <Loading/>}
                                    </div>
                                </FormGroup>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(NewsfeedForm);



/** WEBPACK FOOTER **
 ** ./src/containers/Newsfeeds/NewsfeedForm.js
 **/